import React from "react";
import Carousel from "@ui/carousel";
import ComplexText from "@ui/complex-text";
import { LinkDefault } from "../../ui/links";

const Content = ({ data }) => {
    return (
        <>
            <img src={data.iconUrl} className="mb-4 w-6 h-6" />
            {data.title && (
                <h3 className="text-skin-dark font-semibold">{data.title}</h3>
            )}
            <div className="mt-2 text-sm">
                <ComplexText values={data.text} />
            </div>
            {data.actionLink && (
                <LinkDefault
                    className="mt-3 inline-block text-sm"
                    data={data.actionLink}
                />
            )}
        </>
    );
};

const CarouselWidget = ({ data }) => {
    return (
        <Carousel
            data={data}
            slides={data.items.map((item) => (
                <Content data={item} />
            ))}
        />
    );
};

export default CarouselWidget;
